import { Link } from 'react-router';

interface BackLinkProps {
  to: string;
  label: string;
  className?: string;
}

/**
 * Standard "← Back to X" link used at the top of sub-pages to navigate to the
 * parent page. Matches the pattern originally used on BusinessContext.tsx so
 * it's consistent across every nested route.
 */
export function BackLink({ to, label, className = '' }: BackLinkProps) {
  return (
    <div className={`flex items-center gap-3 mb-6 ${className}`}>
      <Link
        to={to}
        className="text-helm-400 hover:text-helm-300 transition-colors text-sm flex items-center gap-1"
      >
        ← {label}
      </Link>
    </div>
  );
}
